export const videos = [
  {
    id: "1",
    title: "城市夜晚延时摄影：霓虹光影每秒都在变化",
    category: "short",
    author: "光影记录者",
    authorType: "official",
    views: 1286000,
    duration: "02:18",
    publishDate: "2026-10-13",
    daysAgo: 1,
    description:
      "用延时摄影记录下一座城市从黄昏到深夜的全部变化。霓虹灯逐一亮起，车流拉出长长的光轨，每一秒都在讲述城市的心跳。",
    tags: ["延时摄影", "城市", "夜景", "视觉"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20timelapse%20of%20a%20modern%20city%20skyline%20at%20dusk%20with%20glowing%20neon%20lights%20and%20moving%20traffic%20light%20trails%2C%20vibrant%20colors%2C%20high%20detail&width=640&height=360&seq=gg-video-01&orientation=landscape",
  },
  {
    id: "2",
    title: "三分钟教你做手冲咖啡，新手也能学会",
    category: "short",
    author: "咖啡小课堂",
    authorType: "official",
    views: 864000,
    duration: "03:05",
    publishDate: "2026-10-12",
    daysAgo: 2,
    description:
      "从研磨到注水，三分钟带你走完一遍手冲咖啡流程。没有复杂器材，跟着做就能喝到一杯干净的咖啡。",
    tags: ["咖啡", "教程", "手冲", "美食"],
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20pour%20over%20coffee%20brewing%20close%20up%20on%20a%20wooden%20table%20with%20warm%20sunlight%20and%20steam%2C%20minimal%20clean%20background%2C%20food%20photography&width=640&height=360&seq=gg-video-02&orientation=landscape",
  },
  {
    id: "3",
    title: "街头滑板高光时刻合集，动作超丝滑",
    category: "short",
    author: "板仔阿泽",
    authorType: "user",
    views: 542000,
    duration: "01:47",
    publishDate: "2026-10-11",
    daysAgo: 3,
    description:
      "攒了两个月的街头滑板高光镜头，每一次落地都值得回放。滑板不只是运动，更是一种生活态度。",
    tags: ["滑板", "街头", "运动", "高光"],
    cover:
      "https://readdy.ai/api/search-image?query=dynamic%20street%20skateboarder%20mid%20trick%20in%20an%20urban%20concrete%20plaza%2C%20motion%20energy%2C%20golden%20hour%20light%2C%20editorial%20sports%20photography&width=640&height=360&seq=gg-video-03&orientation=landscape",
  },
  {
    id: "4",
    title: "一分钟看完全球最美的十个日落",
    category: "short",
    author: "环球旅行志",
    authorType: "official",
    views: 1532000,
    duration: "01:12",
    publishDate: "2026-10-10",
    daysAgo: 4,
    description:
      "从海岛到雪山，一分钟带你穿越十个最美的日落现场。原来同一颗太阳，可以落下这么多不同的样子。",
    tags: ["日落", "旅行", "风景", "治愈"],
    cover:
      "https://readdy.ai/api/search-image?query=breathtaking%20sunset%20over%20calm%20ocean%20horizon%20with%20warm%20orange%20gradient%20sky%2C%20silhouette%20of%20cliffs%2C%20cinematic%20landscape&width=640&height=360&seq=gg-video-04&orientation=landscape",
  },
  {
    id: "5",
    title: "猫咪日常：它到底在想什么",
    category: "short",
    author: "橘猫铲屎官",
    authorType: "user",
    views: 987000,
    duration: "02:40",
    publishDate: "2026-10-09",
    daysAgo: 5,
    description:
      "每天都被这只猫逗笑，它的每一个表情都像在演一部默剧。记录下它一天的样子，也许你能猜到它在想什么。",
    tags: ["猫咪", "宠物", "日常", "萌宠"],
    cover:
      "https://readdy.ai/api/search-image?query=adorable%20fluffy%20cat%20looking%20curiously%20at%20the%20camera%20on%20a%20soft%20blanket%2C%20warm%20cozy%20indoor%20lighting%2C%20playful%20mood%2C%20pet%20photography&width=640&height=360&seq=gg-video-05&orientation=landscape",
  },
  {
    id: "6",
    title: "极限运动第一视角，心跳直接拉满",
    category: "short",
    author: "极限频道",
    authorType: "official",
    views: 731000,
    duration: "03:22",
    publishDate: "2026-10-08",
    daysAgo: 6,
    description:
      "带上耳机，用第一视角体验山地速降的每一秒钟。风从耳边掠过，心率跟着坡道一起飙升。",
    tags: ["极限运动", "第一视角", "刺激", "户外"],
    cover:
      "https://readdy.ai/api/search-image?query=first%20person%20point%20of%20view%20of%20extreme%20mountain%20biking%20downhill%20on%20a%20rocky%20trail%2C%20motion%20blur%2C%20adrenaline%2C%20daylight&width=640&height=360&seq=gg-video-06&orientation=landscape",
  },
  {
    id: "7",
    title: "爆笑短剧：当室友开始假装健身",
    category: "entertainment",
    author: "快乐剧组",
    authorType: "official",
    views: 2210000,
    duration: "04:36",
    publishDate: "2026-10-13",
    daysAgo: 1,
    description:
      "室友突然宣布要开始健身，结果从第一组动作就开始跑偏。一集短剧，笑点密集到停不下来。",
    tags: ["搞笑", "短剧", "生活", "喜剧"],
    cover:
      "https://readdy.ai/api/search-image?query=two%20young%20friends%20laughing%20in%20a%20bright%20modern%20living%20room%20during%20a%20funny%20workout%20scene%2C%20comedic%20candid%20moment%2C%20natural%20light&width=640&height=360&seq=gg-video-07&orientation=landscape",
  },
  {
    id: "8",
    title: "明星幕后花絮大放送，笑点不断",
    category: "entertainment",
    author: "娱乐前线",
    authorType: "official",
    views: 1680000,
    duration: "05:12",
    publishDate: "2026-10-12",
    daysAgo: 2,
    description:
      "正式拍摄之外的他们原来这么可爱，忘词、笑场、小失误全都被镜头记录了下来。花絮比正片还好看。",
    tags: ["明星", "花絮", "幕后", "综艺"],
    cover:
      "https://readdy.ai/api/search-image?query=backstage%20filming%20set%20with%20stage%20lights%20and%20camera%20crew%2C%20glamorous%20entertainment%20atmosphere%2C%20warm%20tones%2C%20behind%20the%20scenes&width=640&height=360&seq=gg-video-08&orientation=landscape",
  },
  {
    id: "9",
    title: "综艺名场面回顾：这些瞬间太经典",
    category: "entertainment",
    author: "快乐剪辑室",
    authorType: "user",
    views: 1140000,
    duration: "06:24",
    publishDate: "2026-10-11",
    daysAgo: 3,
    description:
      "把过去一年里最出圈的综艺名场面剪在一起，每一个都是弹幕刷屏的存在。回顾一遍，还是会笑出声。",
    tags: ["综艺", "名场面", "回顾", "欢乐"],
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20lively%20tv%20studio%20stage%20with%20bright%20lights%20and%20audience%2C%20entertainment%20show%20atmosphere%2C%20festive%20energy&width=640&height=360&seq=gg-video-09&orientation=landscape",
  },
  {
    id: "10",
    title: "搞笑配音：给动物们配上人类台词",
    category: "entertainment",
    author: "动物配音社",
    authorType: "user",
    views: 903000,
    duration: "03:48",
    publishDate: "2026-10-10",
    daysAgo: 4,
    description:
      "如果动物会说话，它们大概每天都在上演连续剧。给几个搞笑瞬间配上台词，笑果直接翻倍。",
    tags: ["配音", "搞笑", "动物", "创意"],
    cover:
      "https://readdy.ai/api/search-image?query=funny%20close%20up%20of%20a%20surprised%20farm%20animal%20outdoors%2C%20humorous%20expression%2C%20bright%20natural%20daylight%2C%20playful&width=640&height=360&seq=gg-video-10&orientation=landscape",
  },
  {
    id: "11",
    title: "音乐现场：乐队即兴演奏氛围拉满",
    category: "entertainment",
    author: "现场声浪",
    authorType: "official",
    views: 622000,
    duration: "07:05",
    publishDate: "2026-10-09",
    daysAgo: 5,
    description:
      "没有彩排，没有歌单，一整段即兴演奏让整个场地沸腾。戴上耳机，感受现场的温度和呼吸。",
    tags: ["音乐", "现场", "乐队", "即兴"],
    cover:
      "https://readdy.ai/api/search-image?query=live%20band%20performing%20on%20stage%20with%20warm%20stage%20lights%20and%20crowd%20silhouettes%2C%20energetic%20concert%20atmosphere%2C%20cinematic&width=640&height=360&seq=gg-video-11&orientation=landscape",
  },
  {
    id: "12",
    title: "电影级创意短片，一分钟被惊艳到",
    category: "entertainment",
    author: "影像工作室",
    authorType: "user",
    views: 488000,
    duration: "01:30",
    publishDate: "2026-10-07",
    daysAgo: 7,
    description:
      "用一分钟讲一个小故事，画面、光线和节奏全都拉满。看完只想说：这真的是手机能拍出来的吗？",
    tags: ["短片", "创意", "电影感", "视觉"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20moody%20still%20frame%20with%20dramatic%20lighting%20and%20rich%20colors%2C%20film%20production%20aesthetic%2C%20high%20contrast&width=640&height=360&seq=gg-video-12&orientation=landscape",
  },
  {
    id: "13",
    title: "周末露营vlog：山间清晨太治愈了",
    category: "life",
    author: "慢生活日记",
    authorType: "official",
    views: 976000,
    duration: "08:15",
    publishDate: "2026-10-13",
    daysAgo: 1,
    description:
      "把闹钟关掉，去山里睡一晚。清晨拉开帐篷，雾气和阳光一起涌进来，那一刻所有的疲惫都被治愈了。",
    tags: ["露营", "vlog", "治愈", "户外"],
    cover:
      "https://readdy.ai/api/search-image?query=peaceful%20morning%20camping%20scene%20with%20a%20tent%20in%20green%20mountains%20and%20soft%20mist%2C%20warm%20sunrise%20light%2C%20nature%20vlog%20aesthetic&width=640&height=360&seq=gg-video-13&orientation=landscape",
  },
  {
    id: "14",
    title: "十分钟搞定一顿高颜值早餐",
    category: "life",
    author: "厨房提案",
    authorType: "official",
    views: 1105000,
    duration: "05:40",
    publishDate: "2026-10-12",
    daysAgo: 2,
    description:
      "早餐不需要复杂，十分钟就能摆出一桌好心情。简单食材也有高级感，让每一天从认真吃饭开始。",
    tags: ["早餐", "美食", "教程", "居家"],
    cover:
      "https://readdy.ai/api/search-image?query=beautiful%20healthy%20breakfast%20spread%20on%20a%20marble%20table%2C%20fresh%20fruits%20and%20coffee%2C%20bright%20airy%20food%20photography&width=640&height=360&seq=gg-video-14&orientation=landscape",
  },
  {
    id: "15",
    title: "出租屋改造前后对比，空间突然变大了",
    category: "life",
    author: "改造小能手",
    authorType: "user",
    views: 1340000,
    duration: "06:52",
    publishDate: "2026-10-11",
    daysAgo: 3,
    description:
      "花了一个月改造出租屋，没用大预算，只是重新安排了一下空间和光线。前后对比看一遍，你会相信小房间也能住得很舒服。",
    tags: ["改造", "居家", "出租屋", "收纳"],
    cover:
      "https://readdy.ai/api/search-image?query=small%20cozy%20modern%20apartment%20interior%20after%20makeover%20with%20plants%20and%20warm%20wood%20tones%2C%20bright%20and%20tidy%2C%20interior%20photography&width=640&height=360&seq=gg-video-15&orientation=landscape",
  },
  {
    id: "16",
    title: "一个人的城市漫游，记录平凡的小美好",
    category: "life",
    author: "街角观察",
    authorType: "user",
    views: 356000,
    duration: "07:30",
    publishDate: "2026-10-09",
    daysAgo: 5,
    description:
      "没有目的地的城市散步，随手记录下路边的小店、晒太阳的猫和刚出炉的面包香。平凡的日常也值得被喜欢。",
    tags: ["城市", "漫步", "vlog", "日常"],
    cover:
      "https://readdy.ai/api/search-image?query=young%20person%20walking%20through%20a%20quiet%20charming%20city%20street%20with%20cafes%2C%20warm%20afternoon%20light%2C%20casual%20lifestyle%20photography&width=640&height=360&seq=gg-video-16&orientation=landscape",
  },
  {
    id: "17",
    title: "阳台种菜日记：第三十天收获了",
    category: "life",
    author: "阳台农夫",
    authorType: "official",
    views: 421000,
    duration: "04:18",
    publishDate: "2026-10-08",
    daysAgo: 6,
    description:
      "从一粒种子到端上餐桌，三十天的阳台种菜记录。原来不用大院子，一点点阳光和耐心也能吃到自己种的菜。",
    tags: ["种菜", "阳台", "生活", "记录"],
    cover:
      "https://readdy.ai/api/search-image?query=lush%20green%20vegetable%20garden%20on%20a%20sunny%20apartment%20balcony%20with%20potted%20plants%2C%20fresh%20and%20vibrant%2C%20lifestyle%20photography&width=640&height=360&seq=gg-video-17&orientation=landscape",
  },
  {
    id: "18",
    title: "极简收纳技巧，让家瞬间整齐",
    category: "life",
    author: "整理研究所",
    authorType: "official",
    views: 689000,
    duration: "05:26",
    publishDate: "2026-10-07",
    daysAgo: 7,
    description:
      "收纳不是把东西藏起来，而是让每件物品都有自己的位置。几个简单的技巧，让家变得清爽又有秩序感。",
    tags: ["收纳", "极简", "居家", "整理"],
    cover:
      "https://readdy.ai/api/search-image?query=neatly%20organized%20minimalist%20home%20storage%20shelves%20with%20folded%20clothes%20and%20baskets%2C%20clean%20bright%20interior%2C%20tidy%20aesthetic&width=640&height=360&seq=gg-video-18&orientation=landscape",
  },
];

export const heroSlides = [
  {
    videoId: "4",
    tag: "本周焦点",
    title: "一分钟看完全球最美的十个日落",
    subtitle: "跨越山海，只为把最美的黄昏放进你的屏幕里",
    image:
      "https://readdy.ai/api/search-image?query=epic%20panoramic%20sunset%20over%20the%20ocean%20with%20dramatic%20orange%20and%20crimson%20clouds%2C%20warm%20gradient%20sky%2C%20cinematic%20atmosphere&width=1600&height=900&seq=gg-hero-01&orientation=landscape",
  },
  {
    videoId: "7",
    tag: "热门推荐",
    title: "爆笑短剧：当室友开始假装健身",
    subtitle: "笑点密集到停不下来，快乐就是这么简单",
    image:
      "https://readdy.ai/api/search-image?query=vibrant%20warm%20abstract%20stage%20light%20texture%20with%20orange%20and%20amber%20tones%2C%20soft%20glow%2C%20joyful%20atmosphere%20background&width=1600&height=900&seq=gg-hero-02&orientation=landscape",
  },
  {
    videoId: "13",
    tag: "编辑精选",
    title: "周末露营vlog：山间清晨太治愈了",
    subtitle: "关掉闹钟，去山里睡一晚，让生活慢下来",
    image:
      "https://readdy.ai/api/search-image?query=serene%20misty%20mountain%20landscape%20at%20sunrise%20with%20soft%20golden%20light%20and%20layered%20hills%2C%20calm%20cinematic%20nature%20scene&width=1600&height=900&seq=gg-hero-03&orientation=landscape",
  },
  {
    videoId: "1",
    tag: "视觉大片",
    title: "城市夜晚延时摄影：霓虹光影每秒都在变化",
    subtitle: "当城市亮起灯光，每一帧都是值得收藏的风景",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20blurred%20city%20night%20lights%20with%20warm%20orange%20bokeh%20and%20neon%20glow%2C%20dreamy%20cinematic%20background&width=1600&height=900&seq=gg-hero-04&orientation=landscape",
  },
];